import { OnInit, Component, Input } from '@angular/core';
import { FormService } from '../form/form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../shared/services/app.service';
import { Location } from '@angular/common';

@Component({
    selector: 'dhs-form-view',
    templateUrl: './form-view.component.html',
    styleUrls: ['./form-view.component.scss'],
    standalone: false
})
export class FormViewComponent implements OnInit {
    @Input() fieldGroup: any = [];
    @Input() data: any;
    @Input() buttonConf: boolean = true;
    action = 'VIEW';
    fieldGroups: any = [];
    public group_type: any = '';
    activeKey: any; // Need to check
    blockMapping: any;
    constructor(
        private formService: FormService,
        public route: ActivatedRoute,
        public router: Router,
        private appService: AppService,
        private _location: Location
    ) {
    }

    ngOnInit() {
        this.formService.setEditableGrid(false);
        // this.formService.setInitialValues(this);
        this.formService.setForm(this.data);
        this.fieldGroups = this.formService.buildFormGroup(this, this.fieldGroup);
        this.blockMapping = this.fieldGroups;
        console.log('field groups at view is as follows => ', this.fieldGroups);
        this.showData();
    }

    isArray(obj) {
        return obj instanceof Array;
    }
    showData() {
        console.log('input data is ==========>>>', this.data, "field group", this.fieldGroup);
    }

    cancelButtonClick() {
        if (this.route.snapshot.queryParams.hasOwnProperty('returnUrl') && this.route.snapshot.queryParams.hasOwnProperty('tab')) {
            window.location.reload();
        } else if (this.route.snapshot.queryParams.hasOwnProperty('returnUrl')) {
            this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
        } else {
            // let current = (this.route.snapshot.data.view == undefined) ? this.route.snapshot.data.resource : this.route.snapshot.data.view;
            // const url = '/' + this.appService.getApplication() + '/' + current + '/list';
            // this.router.navigate([url]);
            this._location.back();
        }
    }
    public onValueChanged(e: any) {
        console.log("onValueChanged", e);
        if (e.val != undefined) {
            let arrayVal: any = "";
            let objVal: any = "";
            let flag: boolean = false;
            if (e.question != undefined && e.question.dependents != undefined && e.question.dependents.length) {
                for (let index = 0; index < e.question.dependents.length; index++) {
                    var dependents = e.question.dependents[index];
                    /**
                     * for multivalue action eg:value=[a,b],action:any(enable disable etc)
                     */
                    if (Array.isArray(dependents.value)) {
                        arrayVal = dependents.value;
                        let val: any = false;
                        val = dependents.value.find(x => x == e.val);
                        if (val || val == "") {
                            dependents['value'] = val;
                            flag = true;
                        }
                    }
                    /**
                     * case to handle populate fields & others
                     */
                    if (typeof (e.val) == "object") {
                        objVal = JSON.parse(JSON.stringify(e.val));
                        if (dependents.action != "populate_field") {
                            e.val = e.val[e.question.getterKey];
                        } else {
                            if (Array.isArray(objVal) && objVal.length > 0) {
                                objVal = objVal[0]; //for populate fields we can't work with multiple value hence taking first value by default
                            }
                        }
                    }
                    if (dependents.action != undefined) {
                        if (dependents.dependent_field != undefined) {
                            let conditionMet = false;
                            let conditionNotMet = false;
                            if (typeof objVal == 'object') {
                                if (Array.isArray(objVal)) {

                                    var allVals = [];
                                    if (e.question != undefined && e.question.controlType != undefined && (e.question.controlType == 'searchselect')) {
                                        if (dependents.getterKey != undefined) {
                                            allVals = objVal.map(a => {
                                                if (e.question.options) {
                                                    var selected = e.question.options.find(x => x['id'] == a.id);
                                                    return selected[dependents.getterKey];
                                                }
                                            });
                                        } else {
                                            allVals = objVal.map(a => a['text']);
                                        }

                                    } else {
                                        allVals = objVal.map(a => a[e.question.getterKey]);
                                    }

                                    conditionMet = allVals.length > 0 && (dependents.value == undefined || (dependents.value != undefined && (dependents.value || dependents.value == "") && allVals.indexOf(dependents.value) > -1));

                                    conditionNotMet = allVals.length == 0 || (dependents.value != undefined && (dependents.value || dependents.value == "") && allVals.indexOf(dependents.value) == -1);
                                } else {


                                    if (dependents.action == "populate_field") {
                                        if (e.question != undefined && e.question.controlType != undefined && (e.question.controlType == 'searchselect')) {
                                            if (e.question.options) {
                                                var selected = e.question.options.find(x => x['id'] == objVal.id);
                                                if (selected && selected[dependents.value] != undefined) {
                                                    objVal = selected[dependents.value];
                                                } else {
                                                    objVal = '';//value not found in options
                                                    break;
                                                }
                                            } else {
                                                objVal = '';//value not found in options
                                                break;
                                            }
                                        }

                                        conditionMet = (dependents.value == undefined || (dependents.value != undefined && (dependents.value || dependents.value == "") && objVal != ''));
                                        conditionNotMet = (dependents.value != undefined && (dependents.value || dependents.value == "") && Object.keys(objVal).length == 0);
                                    } else {

                                        if (dependents.value != undefined && typeof dependents.value == 'object' && Array.isArray(dependents.value)) {
                                            conditionMet = (dependents.value == undefined || ((dependents.value.length) && (objVal[e.question.getterKey] != undefined && dependents.value.indexOf(objVal[e.question.getterKey]) > -1)));
                                            conditionNotMet = (dependents.value != undefined && (dependents.value.length) && (objVal[e.question.getterKey] != undefined && dependents.value.indexOf(objVal[e.question.getterKey]) == -1));
                                        } else {
                                            conditionMet = (dependents.value == undefined || (dependents.value != undefined && (dependents.value || dependents.value == "") && (objVal[e.question.getterKey] != undefined && objVal[e.question.getterKey] == dependents.value)));
                                            conditionNotMet = (dependents.value != undefined && (dependents.value || dependents.value == "") && (objVal[e.question.getterKey] != undefined && objVal[e.question.getterKey] != dependents.value));
                                        }

                                    }

                                }
                            } else { //when value is string
                                //when dependent value is array
                                if (dependents.value != undefined && typeof dependents.value == 'object' && Array.isArray(dependents.value)) {
                                    conditionMet = ((dependents.value == undefined && e.val != '') || (dependents.value != undefined && (dependents.value || dependents.value == "") && dependents.value.indexOf(e.val) > -1));
                                    conditionNotMet = (dependents.value == undefined && e.val == '') || (dependents.value != undefined && (dependents.value || dependents.value == "") && dependents.value.indexOf(e.val) == -1);
                                } else {
                                    //when dependent value is string
                                    conditionMet = ((dependents.value == undefined && e.val != '') || (dependents.value != undefined && (dependents.value || dependents.value == "") && dependents.value == e.val));
                                    conditionNotMet = (dependents.value == undefined && e.val == '') || (dependents.value != undefined && (dependents.value || dependents.value == "") && dependents.value != e.val);
                                }

                            }

                            var question = this.formService.questionMapping[dependents.dependent_field];
                            if (!question) {
                                if (e.question.key && e.question.key.includes('.')) {//for composite
                                    if (e.question.key.lastIndexOf('.') > - 1) {
                                        question = this.formService.questionMapping[e.question.key.substring(0, e.question.key.lastIndexOf('.')) + '.' + dependents.dependent_field];
                                    }
                                }
                            }
                            if (conditionMet && question) {
                                switch (dependents.action) {
                                    case 'change_value':
                                        var cloneDependant = JSON.parse(JSON.stringify(dependents));
                                        if (cloneDependant.args != undefined && e.val) {
                                            cloneDependant.args = cloneDependant.args.replace('!!!getterKey!!!', e.val);
                                        }
                                        else if (cloneDependant.search != undefined && e.val) {
                                            cloneDependant.search = cloneDependant.search.replace('!!!getterKey!!!', e.val);
                                        }
                                        if (cloneDependant.filter != undefined && e.val) {
                                            cloneDependant.filter = cloneDependant.filter.replace('!!!getterKey!!!', e.val);
                                        } else if (cloneDependant.composite_args != undefined && cloneDependant.composite_args.length > 0) {

                                            cloneDependant.args = this.setArgs(cloneDependant);
                                        }
                                        var field: any = {};
                                        field.datasource = cloneDependant;
                                        field.getterKey = question.getterKey;
                                        field.getterValue = question.getterValue;
                                        field.req_keys = question.req_keys;
                                        this.formService.setdropdownOptions(field, question, this);
                                        this.onValueChanged({ question: question, val: e.val });
                                        break;
                                    case 'visible':
                                        this.setFieldVisibiltiy(question, true);
                                        break;
                                    case 'invisible':
                                        this.setFieldVisibiltiy(question, false);
                                        break;
                                    default:
                                        //do nothing
                                        break;
                                }
                            } else if (conditionNotMet && question) {
                                switch (dependents.action) {
                                    case 'change_value':
                                        var cloneDependant: any = {};
                                        cloneDependant.possible_value = [];
                                        var field: any = {};
                                        field.datasource = cloneDependant;
                                        field.req_keys = question.req_keys;
                                        this.formService.setdropdownOptions(field, question, this);
                                        this.onValueChanged({ question: question, val: '' });
                                        break;
                                    case 'visible':
                                        this.setFieldVisibiltiy(question, false);
                                        break;
                                    case 'invisible':
                                        this.setFieldVisibiltiy(question, true);
                                        break;
                                    default:
                                        //do nothing
                                        break;
                                }
                            }
                        }
                        else if (dependents.dependent_block != "" || dependents.dependent_block != undefined) {
                            var block = this.blockMapping.find(x => x['name'] == dependents['dependent_block']);
                            if (block) {
                                switch (dependents.action) {
                                    case 'visible':
                                        //if its dependent value is string then it should be equeal if array then it should be present 
                                        if ((typeof dependents['value'] != 'object' && dependents['value'] == e.val) || (typeof dependents['value'] == 'object' && Array.isArray(dependents['value']) && dependents['value'].indexOf(e.val) > -1)) {
                                            this.setBlockVisibiltiy(block, true);
                                        }
                                        else {
                                            this.setBlockVisibiltiy(block, false);
                                        }
                                        // })

                                        break;
                                    case 'invisible':
                                        if ((typeof dependents['value'] != 'object' && dependents['value'] == e.val) || (typeof dependents['value'] == 'object' && Array.isArray(dependents['value']) && dependents['value'].indexOf(e.val) > -1)) {
                                            this.setBlockVisibiltiy(block, false);
                                        }
                                        else {
                                            this.setBlockVisibiltiy(block, true);
                                        }
                                        break;

                                    default:
                                        //do nothing
                                        break;
                                }
                            }
                        }
                    }
                    if (flag) {
                        dependents['value'] = arrayVal;
                        flag = false;
                    }
                    if (dependents.action != "populate_field" && objVal != "") {
                        e.val = objVal;
                    }
                }
            }
        }


    }

    setArgs(value) {
        let args = [];
        for (let i = 0; i < value.composite_args.length; i++) {
            if (value.composite_args[i].type == 'dynamic' && this.formService.questionMapping && this.formService.questionMapping[value.composite_args[i].value] != undefined) {
              let val = value.composite_args[i].key + ":" + this.formService.questionMapping[value.composite_args[i].value].value;
              args.push(val);
            } else if(value.composite_args[i]!=undefined && !value.composite_args[i].setNull) {
              let val = value.composite_args[i].key + ":" + value.composite_args[i].value;
              args.push(val);
            }
    
        }
        return args.join();
      }
    setFieldVisibiltiy(question, visibility, emit_change = true) {
        this.setFormFieldVisiblity(question, visibility);
        // if (emit_change && this.form != undefined && this.form && this.form.controls[question.key] != undefined && this.form.controls[question.key]['question_component'] != undefined) {
        //     this.form.controls[question.key]['question_component'].updateDependentValue(this.form.controls[question.key].value);
        // }
    }
    setFormFieldVisiblity(question, visibility) {
        question.visible = visibility;
    }
    setBlockVisibiltiy(block, visibility) {
        block['visible'] = visibility;
        for (let question of block.questions) {
            // check if its a block then loop through its questions.
            if (Array.isArray(question)) {
                if (question[0].questions != undefined) {
                    for (let singleQuestion of question[0]['questions']) {
                        if (visibility) {
                            this.setFieldVisibiltiy(singleQuestion, visibility);
                        } else {
                            this.setFieldVisibiltiy(singleQuestion, visibility, false);
                        }
                    }
                }
            }
            else {
                if (visibility) {
                    this.setFieldVisibiltiy(question, visibility);
                } else {
                    this.setFieldVisibiltiy(question, visibility, false);
                }
            }
        }
        // this.cdr.detectChanges();//to prevent expression changed after checked error
    }
}